import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// ANT COMPONENTS
import { Col, Row } from 'antd';
// CUSTOM COMPONENTS
import Greeting from 'components/greeting';
import Header from 'components/header';
import Banner from 'components/banner';
// HOOKS
import useDevice from 'hooks/useDevice';
// VIEWS
import Info from './info';

const Main = ({ ui }) => {
  const { product } = ui;
  const { mobile, desktop } = useDevice();

  const getDeviceText = (source = '') => {
    if (source) {
      if (desktop && source.hasOwnProperty('desktop')) {
        return source.desktop;
      } else if (mobile && source.hasOwnProperty('mobile')) {
        return source.mobile;
      }
    }

    return source;
  };

  const headline = getDeviceText(product.headline);
  const title = getDeviceText(product.title);
  const subtitle = getDeviceText(product.subtitle);
  const greeting = getDeviceText(product.greeting);

  if (title) {
    document.title = title;
  }

  return (
    <form
      noValidate
      id="frm"
      autoComplete="off"
      className={classnames({ 'new-mobile': mobile })}>
      <Row type="flex">
        <Col xs={24} md={desktop ? 15 : 24}>
          {mobile && <Banner title={title} />}
          <div
            className={classnames('abasCanais', {
              mt5: !product.greeting,
              ph3: desktop,
            })}>
            {greeting && (
              <Row type="flex" justify="center">
                <Col xs={24}>
                  <Greeting message={greeting} />
                </Col>
              </Row>
            )}
            <Row type="flex" justify="center">
              <Col
                xs={24}
                className={classnames({ ph3: mobile, header: mobile })}>
                <Header title="Pelo telefone" />
              </Col>
            </Row>
            <Row type="flex" justify="center">
              <Col xs={24} md={24}>
                <div
                  id="byside_carrinho_c2c"
                  data-show="canalAba[1]"
                  className="show"
                />
              </Col>
            </Row>
          </div>
        </Col>
        {desktop && !mobile && (
          <Col
            xs={0}
            md={9}
            className="fixed vh-100 right-0"
            style={{ backgroundColor: 'whitesmoke' }}>
            <Info
              headline={headline}
              title={title}
              subtitle={subtitle}
              features={product.features}
            />
          </Col>
        )}
      </Row>
    </form>
  );
};

Main.propTypes = {
  ui: PropTypes.object,
};

export default Main;
